/* eslint-disable */
import $ from 'jquery';
import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import CommonClass from '../../js/common';
import {
    HOME_PAGE_UNLOADED
} from '../../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.home,
    appName: state.common.appName,
    token: state.common.token
});

const mapDispatchToProps = dispatch => ({
    onUnload: () =>
        dispatch({ type: HOME_PAGE_UNLOADED })
});

class RegisterMenu extends React.Component {
    componentWillMount() {

    }
    componentDidMount() {
        var CONTAINER_ORIGINAL_WIDTH = $('#MainContainer').css('width');
        var CONTAINER_ORIGINAL_HEIGHT = $('#MainContainer').css('height');

        var CONTAINER1_ORIGINAL_WIDTH = $(window).width();
        var CONTAINER1_ORIGINAL_HEIGHT = $(window).height();

        var mobileHightAdj = 50;
        var mobileWidthAdj = 50;

        var resizePadding = 1;
        var mousehover = 0;

        var isPortrait = false;
        var isMobile = false;

        if (window.matchMedia("(orientation: portrait)").matches) {
            isPortrait = true;
        }

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
            .test(navigator.userAgent)) {
            mousehover = 1;
            isMobile = true;
        } else {
            if (isPortrait == true) {
                $("#portrait-blocker").hide();
            }
        }
        // if (isMobile == false) {
        $("#MainContainer").css('width', CONTAINER_ORIGINAL_WIDTH);
        $("#MainContainer").css('height', CONTAINER_ORIGINAL_HEIGHT);

        var screen = {
            left: 0,
            top: 0,
            width: 0,
            height: 0
        };

        screen.width = window.innerWidth;
        screen.height = window.innerHeight;
        var scaleTo = 1;

        screenresize(true);;

        $(window).resize(function () {
            screenresize(true);;
        });
        //  }

        function screenresize(isonload) {

            var width = $(window).width();
            var height = $(window).height();

            var maxWidth = window.screen.width;
            var maxHeight = window.screen.height;

            if (resizePadding == 1) {
                maxHeight = maxHeight + (mobileHightAdj);
                maxWidth = maxWidth + (mobileWidthAdj);
            }

            var scaleTo;

            if (width >= maxWidth && height >= maxHeight) {
                scaleTo = 1;
            } else {
                scaleTo = Math.min(width / maxWidth, height / maxHeight);
            }

           // $('#MainContainer').css({ "transform": "scale(" + scaleTo + ")" });

            var containerLeft = 0;
            if ($(window).width() < parseInt(CONTAINER_ORIGINAL_WIDTH.replace("px", ""))) {
                containerLeft = - (parseInt(CONTAINER_ORIGINAL_WIDTH.replace("px", "")) - $(window).width()) / 2;
            }
            $('#MainContainer').css('left', containerLeft);

            var containerTop = (height - (maxHeight * scaleTo)) / 2;

            if ($('.content-container').hasClass('active') == true) {
                $("#MainContainer").css('width', CONTAINER1_ORIGINAL_WIDTH);
                $("#MainContainer").css('height', CONTAINER1_ORIGINAL_HEIGHT);
            }
        }

        switch (CommonClass.componentPage) {
            case "aboutus":
                $("#AboutUs").addClass("active");
                $("#ContactUs,#Products,#Team").removeClass("active");
                break;
            case "product":
                $("#Products").addClass("active");
                $("#ContactUs,#AboutUs,#Team").removeClass("active");
                break;
            case "contactus":
                $("#ContactUs").addClass("active");
                $("#Products,#AboutUs,#Team").removeClass("active");
                break;
            case "team":
                $("#Team").addClass("active");
                $("#Products,#AboutUs,#ContactUs").removeClass("active");
                break;
            default:
                break;
        }

    }
    componentWillUnmount() {
        this.props.onUnload();
    }
    render() {
        return (
            <div>
                <svg version="1.1" className="navigation hud-height" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 1000 800" style={{ 'enableBackground': 'new 0 0 1000 800' }} xmlSpace="preserve">

                    <linearGradient id="CircleOuterDark_2_" gradientUnits="userSpaceOnUse" x1="40.6251" y1="400" x2="959.3749" y2="400">
                        <stop offset="0" style={{ 'stopColor': '#777' }} />
                        <stop offset="4.481354e-02" style={{ 'stopColor': '#777', 'stopOpacity': '0.9104' }} />
                        <stop offset="0.5" style={{ 'stopColor': '#777', 'stopOpacity': '0' }} />
                        <stop offset="0.9552" style={{ 'stopColor': '#777', 'stopOpacity': '0.9104' }} />
                        <stop offset="1" style={{ 'stopColor': '#777' }} />
                    </linearGradient>
                    <path id="CircleOuterDark_1_" className="nav-dial0" d="M500,859c62,0,122.1-12.1,178.7-36.1c54.7-23.1,103.7-56.2,145.9-98.4
                        c42.2-42.2,75.3-91.2,98.4-145.9C946.9,522.1,959,462,959,400s-12.1-122.1-36.1-178.7c-23.1-54.7-56.2-103.7-98.4-145.9
	c-42.2-42.2-91.2-75.3-145.9-98.4C622.1-46.9,562-59,500-59c-62,0-122.1,12.1-178.7,36.1C266.7,0.2,217.6,33.3,175.4,75.4
	c-42.2,42.2-75.3,91.2-98.4,145.9C53.1,277.9,41,338,41,400s12.1,122.1,36.1,178.7c23.1,54.7,56.2,103.7,98.4,145.9
	c42.2,42.2,91.2,75.3,145.9,98.4C377.9,846.9,438,859,500,859"/>
<linearGradient id="CircleInnerLight_1_" gradientUnits="userSpaceOnUse" x1="163.0997" y1="368.9752" x2="774.8507" y2="368.9752" gradientTransform="matrix(6.123234e-17 1 -1 6.123234e-17 868.9752 -68.9752)">
                        <stop offset="0" style={{ 'stopColo': '#777' }} />
                        <stop offset="4.481354e-02" style={{ 'stopColor': '#777', 'stopOpacity': '0.9104' }} />
                        <stop offset="0.5" style={{ 'stopColor': '#777', 'stopOpacity': '0' }} />
                        <stop offset="0.9552" style={{ 'stopColor': '#777', 'stopOpacity': '0.9104' }} />
                        <stop offset="1" style={{ 'stopColor': '#777' }} />
                    </linearGradient>
                    <path id="CircleInnerLight" className="nav-dial1" d="M194.5,400c0,41.2,8.1,81.3,24,118.9c15.4,36.4,37.4,69.1,65.5,97.1
                        c28.1,28.1,60.7,50.1,97.1,65.5c37.7,15.9,77.7,24,118.9,24s81.3-8.1,118.9-24c36.4-15.4,69.1-37.4,97.1-65.5
	c28.1-28.1,50.1-60.7,65.5-97.1c15.9-37.7,24-77.7,24-118.9c0-41.2-8.1-81.3-24-118.9C766.1,244.7,744.1,212,716,184
	c-28.1-28.1-60.7-50.1-97.1-65.5c-37.7-15.9-77.7-24-118.9-24s-81.3,8.1-118.9,24C344.7,133.9,312,155.9,284,184
	c-28.1,28.1-50.1,60.7-65.5,97.1C202.6,318.7,194.5,358.8,194.5,400"/>
<linearGradient id="CircleOuterDark_3_" gradientUnits="userSpaceOnUse" x1="500" y1="831.8762" x2="500" y2="-31.8762">
                        <stop offset="0" style={{ 'stopColor': '#777' }} />
                        <stop offset="4.481354e-02" style={{ 'stopColor': '#777', 'stopOpacity': '0.9104' }} />
                        <stop offset="0.5" style={{ 'stopColor': '#777', 'stopOpacity': '0' }} />
                        <stop offset="0.9552" style={{ 'stopColor': '#777', 'stopOpacity': '0.9104' }} />
                        <stop offset="1" style={{ 'stopColor': '#777' }} />
                    </linearGradient>
                    <path id="CircleOuterDark" className="nav-dial2" d="M500,831.5c58.3,0,114.8-11.4,168-33.9c51.4-21.7,97.5-52.8,137.2-92.5
                        c39.6-39.6,70.7-85.8,92.5-137.2c22.5-53.2,33.9-109.7,33.9-168s-11.4-114.8-33.9-168c-21.7-51.4-52.8-97.5-92.5-137.2
	C765.5,55.3,719.3,24.1,668,2.4c-53.2-22.5-109.7-33.9-168-33.9c-58.3,0-114.8,11.4-168,33.9c-51.4,21.7-97.5,52.8-137.2,92.5
	c-39.6,39.6-70.7,85.8-92.5,137.2c-22.5,53.2-33.9,109.7-33.9,168s11.4,114.8,33.9,168c21.7,51.4,52.8,97.5,92.5,137.2
	c39.6,39.6,85.8,70.7,137.2,92.5C385.2,820.1,441.7,831.5,500,831.5"/>
<linearGradient id="CircleInnerDark_1_" gradientUnits="userSpaceOnUse" x1="500" y1="727.876" x2="500" y2="72.124">
                        <stop offset="0" style={{ 'stopColor': '#777' }} />
                        <stop offset="4.481354e-02" style={{ 'stopColor': '#777', 'stopOpacity': '0.9104' }} />
                        <stop offset="0.5" style={{ 'stopColor': '#777', 'stopOpacity': '0' }} />
                        <stop offset="0.9552" style={{ 'stopColor': '#777', 'stopOpacity': '0.9104' }} />
                        <stop offset="1" style={{ 'stopColor': '#777' }} />
                    </linearGradient>
                    <path id="CircleInnerDark" className="nav-dial3" d="M500,727.5c44.2,0,87.1-8.7,127.5-25.7c39-16.5,74-40.1,104.1-70.2
                        c30.1-30.1,53.7-65.1,70.2-104.1c17.1-40.4,25.7-83.3,25.7-127.5s-8.7-87.1-25.7-127.5c-16.5-39-40.1-74-70.2-104.1
	c-30.1-30.1-65.1-53.7-104.1-70.2C587.1,81.2,544.2,72.5,500,72.5c-44.2,0-87.1,8.7-127.5,25.7c-39,16.5-74,40.1-104.1,70.2
	c-30.1,30.1-53.7,65.1-70.2,104.1c-17.1,40.4-25.7,83.3-25.7,127.5s8.7,87.1,25.7,127.5c16.5,39,40.1,74,70.2,104.1
	c30.1,30.1,65.1,53.7,104.1,70.2C412.9,718.8,455.8,727.5,500,727.5"/>
<circle className="nav-dial4" cx="500" cy="400" r="346.5" />


                    <NavLink to="/aboutus" exact>  <g id="AboutUs" className="menushow" onClick={this.showAboutUs}>
                        <path className="nav-dial5" d="M49.5,386c0,0-0.2-49.6,14-104.8c0,0,9.8-34.8,30.7-78.1l86.3,77.6c0,0-16.9,72.6-17.9,107.3L49.5,386z" />
                        <path className="nav-dial6" d="M122.3,293.3c-0.3,0.8-0.7,1.4-1.2,1.8c-0.5,0.4-0.9,0.6-1.4,0.7c-0.1-0.2-0.1-0.5-0.2-0.7
                            c0.5-0.1,0.9-0.4,1.3-0.7c0.4-0.3,0.7-0.8,0.9-1.4c0.3-0.7,0.3-1.3,0.2-1.8c-0.1-0.5-0.5-0.9-1-1.1c-0.3-0.1-0.6-0.2-0.9-0.2
		c-0.3,0-0.6,0.1-0.8,0.2c-0.3,0.1-0.5,0.3-0.8,0.6c-0.3,0.3-0.6,0.6-0.9,1c-0.6,0.8-1.2,1.3-1.7,1.5c-0.5,0.2-1,0.3-1.6,0
		c-0.6-0.2-1-0.6-1.3-1.3c-0.2-0.6-0.2-1.4,0.2-2.4c0.3-0.7,0.6-1.3,1.1-1.7c0.4-0.4,0.9-0.6,1.4-0.7c0,0.2,0.1,0.5,0.1,0.7
		c-0.4,0.1-0.8,0.3-1.1,0.5c-0.4,0.3-0.7,0.7-0.9,1.3c-0.3,0.7-0.3,1.3-0.1,1.8c0.2,0.5,0.5,0.8,0.9,0.9c0.2,0.1,0.5,0.1,0.7,0.1
		c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.4-0.3,0.7-0.6c0.2-0.3,0.5-0.6,0.9-1c0.6-0.8,1.2-1.3,1.8-1.5c0.6-0.2,1.3-0.2,2.1,0.1
		c0.8,0.3,1.2,0.8,1.4,1.5C122.7,291.7,122.6,292.4,122.3,293.3z M120.2,298.6c-0.4-0.1-0.7-0.2-1-0.3c0.2,0.4,0.3,1,0.4,1.5
		c0.1,0.6,0,1.3-0.2,2c-0.2,0.5-0.4,0.9-0.6,1.3c-0.3,0.4-0.6,0.7-0.9,0.9c-0.4,0.2-0.8,0.4-1.3,0.4c-0.5,0-1,0-1.6-0.2
		c-2-0.6-4-1.2-6-1.7c0.1-0.2,0.1-0.5,0.2-0.8c2,0.6,3.9,1.2,5.9,1.8c0.5,0.1,0.9,0.2,1.3,0.2c0.4,0,0.7-0.1,1-0.3
		c0.3-0.2,0.6-0.4,0.8-0.7c0.2-0.3,0.4-0.7,0.5-1.1c0.2-0.7,0.3-1.3,0.2-1.9c-0.1-0.6-0.3-1.2-0.6-1.7c-2.4-0.8-4.8-1.6-7.2-2.4
		c0.1-0.2,0.2-0.5,0.3-0.7c3,1,6,2,9,3.1C120.3,298.2,120.3,298.4,120.2,298.6z M116.5,311.9c-0.1,0.5-0.4,0.9-0.8,1.2
		c-0.4,0.3-0.9,0.3-1.5,0.2c-2.3-0.6-4.6-1.1-6.9-1.7c-0.1,0.6-0.3,1.2-0.4,1.7c-0.2,0-0.4-0.1-0.6-0.1c0.1-0.6,0.3-1.2,0.4-1.7
		c-0.8-0.2-1.6-0.4-2.4-0.6c0.1-0.3,0.1-0.5,0.2-0.8c0.8,0.2,1.6,0.4,2.4,0.6c0.2-0.9,0.4-1.8,0.7-2.6c0.2,0.1,0.4,0.1,0.6,0.2
		c-0.2,0.9-0.5,1.8-0.7,2.6c2.3,0.6,4.5,1.1,6.8,1.7c0.5,0.1,0.9,0.1,1.2-0.1c0.3-0.2,0.5-0.5,0.6-0.9c0.1-0.3,0.1-0.5,0.1-0.7
		c0-0.2-0.1-0.4-0.1-0.6c0.2-0.1,0.4-0.1,0.6-0.2c0.1,0.3,0.1,0.5,0.1,0.8C116.7,311.1,116.6,311.5,116.5,311.9z M115.1,317.2
		c-0.4,0-0.7-0.1-1.1-0.1c0.2,0.4,0.5,0.9,0.6,1.5c0.2,0.6,0.1,1.2,0,2c-0.1,0.5-0.3,1-0.5,1.4c-0.2,0.4-0.5,0.7-0.8,1
		c-0.3,0.3-0.7,0.4-1.2,0.5c-0.5,0.1-1,0.1-1.6,0c-2-0.4-4.1-0.7-6.1-1.1c0-0.3,0.1-0.5,0.1-0.8c2,0.4,4.1,0.7,6.1,1.1
		c0.5,0.1,1,0.1,1.3,0c0.4-0.1,0.7-0.2,1-0.4c0.3-0.2,0.5-0.5,0.7-0.8c0.2-0.3,0.3-0.7,0.4-1.1c0.1-0.7,0.1-1.3-0.1-1.9
		c-0.2-0.6-0.4-1.1-0.8-1.6c-2.5-0.5-4.9-1.1-7.4-1.6c0.1-0.3,0.1-0.5,0.2-0.8c3.1,0.7,6.2,1.4,9.3,2.1
		C115.1,316.8,115.1,317,115.1,317.2z M112.1,328.7c-0.2-0.5-0.5-0.9-0.8-1.3c-0.4-0.4-0.8-0.7-1.3-0.9c-0.5-0.2-1-0.4-1.5-0.5
		c-0.5-0.1-1.1-0.1-1.6,0c-0.5,0.1-1,0.2-1.5,0.5c-0.4,0.2-0.8,0.6-1.1,1c-0.3,0.4-0.5,0.9-0.6,1.6c-0.1,0.6,0,1.2,0.2,1.7
		c0.2,0.5,0.5,0.9,0.8,1.3c0.4,0.3,0.8,0.6,1.3,0.8c0.5,0.2,1,0.3,1.5,0.4c0.5,0.1,1.1,0.1,1.6,0c0.5-0.1,1-0.2,1.5-0.5
		c0.4-0.2,0.8-0.6,1.1-1c0.3-0.4,0.5-0.9,0.6-1.5C112.4,329.7,112.3,329.1,112.1,328.7z M113,330.3c-0.1,0.7-0.3,1.3-0.7,1.8
		c-0.3,0.5-0.8,0.9-1.3,1.2c-0.5,0.3-1.1,0.5-1.7,0.6c-0.6,0.1-1.3,0.1-1.9,0.1c-0.6-0.1-1.2-0.2-1.8-0.5c-0.6-0.3-1.1-0.6-1.5-1
		c-0.4-0.4-0.7-0.9-0.9-1.5s-0.2-1.3-0.1-2c0.1-0.7,0.3-1.3,0.7-1.8c0.4-0.5,0.8-0.9,1.3-1.2c0.5-0.3,1.1-0.5,1.7-0.6
		c0.6-0.1,1.3-0.1,1.9,0c0.7,0.1,1.3,0.3,1.8,0.6c0.6,0.3,1.1,0.6,1.4,1.1c0.4,0.4,0.7,0.9,0.9,1.5C113,329,113,329.7,113,330.3z
		 M111,339.2c-0.2-0.5-0.4-1-0.8-1.4c-0.4-0.4-0.8-0.7-1.3-1c-0.5-0.3-1.1-0.4-1.8-0.5c-0.7-0.1-1.3,0-1.8,0.1
		c-0.6,0.1-1,0.4-1.4,0.7c-0.4,0.3-0.7,0.7-1,1.2c-0.2,0.5-0.4,1-0.4,1.5c0,0.5,0,1,0.2,1.5c0.1,0.5,0.3,0.9,0.6,1.3
		c2.5,0.2,4.9,0.3,7.4,0.5c0.2-0.3,0.3-0.7,0.4-1.1c0.1-0.4,0.2-0.8,0.2-1.1C111.2,340.3,111.2,339.8,111,339.2z M111.5,342.6
		c-0.1,0.5-0.3,1-0.5,1.4c-4.3-0.3-8.7-0.5-13-0.8c0-0.3,0-0.5,0-0.8c1.5,0.1,2.9,0.2,4.4,0.3c-0.2-0.3-0.3-0.7-0.5-1.2
		c-0.1-0.5-0.2-1.1-0.1-1.7c0-0.6,0.2-1.2,0.4-1.7c0.2-0.5,0.6-1,1-1.4c0.4-0.4,1-0.7,1.6-0.8c0.6-0.2,1.4-0.2,2.2-0.1
		c0.8,0.1,1.5,0.3,2.1,0.6c0.6,0.3,1.1,0.7,1.5,1.2c0.4,0.5,0.7,1,0.9,1.6c0.2,0.6,0.3,1.2,0.2,1.9
		C111.8,341.5,111.7,342.1,111.5,342.6z M105.6,347c0,0.7,0,1.3,0.1,2c0.1,0.7,0.2,1.3,0.4,1.8c0.2,0.5,0.5,1,0.9,1.3
		c0.4,0.3,0.9,0.5,1.5,0.5c0.4,0,0.7-0.1,1-0.2c0.3-0.1,0.5-0.3,0.7-0.6c0.2-0.2,0.3-0.5,0.4-0.8c0.1-0.3,0.2-0.6,0.2-1
		c0-0.6-0.1-1.2-0.3-1.7c-0.2-0.5-0.5-0.9-0.8-1.3C108.2,347.1,106.9,347,105.6,347z M110.4,347.1c0.3,0.3,0.5,0.8,0.7,1.2
		c0.2,0.5,0.3,1.1,0.2,1.8c0,1-0.3,1.8-0.8,2.3c-0.5,0.6-1.2,0.9-2.1,0.9c-0.7,0-1.3-0.2-1.8-0.6c-0.5-0.4-0.8-0.8-1.1-1.5
		c-0.3-0.6-0.4-1.3-0.5-2.1c-0.1-0.8-0.1-1.6-0.1-2.4c-0.2,0-0.4,0-0.6,0c-0.7,0-1.2,0.2-1.7,0.6c-0.4,0.4-0.6,1-0.6,1.8
		c0,0.6,0.1,1.1,0.3,1.6c0.2,0.5,0.5,0.8,0.8,1.1c-0.1,0.2-0.3,0.4-0.4,0.5c-0.3-0.3-0.6-0.7-0.9-1.3c-0.3-0.5-0.4-1.2-0.4-1.9
		c0-1.1,0.3-1.9,0.9-2.5c0.5-0.5,1.3-0.7,2.2-0.7c2.3,0.1,4.5,0.2,6.8,0.3c0,0.2,0,0.4,0,0.7C110.9,347.1,110.7,347.1,110.4,347.1z"
		/>
</g>

                    </NavLink>

                    <NavLink to="/contactus" exact>           <g id="ContactUs" className="menushow" onClick={this.showContactUs}>
                        <path className="nav-dial5" d="M49.5,391.6l113,1c0,0-0.7,68.3,12,96l-96,81C78.5,569.6,45.1,492.7,49.5,391.6z" />
                        <path className="nav-dial6" d="M111,420.2c-0.3,0.5-0.7,0.9-1.1,1.1c-0.1-0.2-0.2-0.4-0.4-0.6c0.4-0.3,0.7-0.6,1-1c0.3-0.4,0.4-0.9,0.5-1.5
                            c0-0.7-0.1-1.3-0.4-1.8c-0.3-0.5-0.7-0.7-1.3-0.8c-0.4,0-0.7,0-0.9,0.1c-0.3,0.1-0.5,0.2-0.7,0.4c-0.2,0.2-0.4,0.5-0.6,0.8
		c-0.2,0.3-0.4,0.7-0.6,1.2c-0.4,0.9-0.7,1.6-1.1,1.9c-0.4,0.4-0.9,0.5-1.6,0.5c-0.7,0-1.2-0.3-1.6-0.9c-0.4-0.5-0.6-1.3-0.5-2.3
		c0-0.8,0.2-1.4,0.5-1.9c0.3-0.5,0.7-0.8,1.1-1c0.1,0.2,0.2,0.4,0.3,0.6c-0.3,0.2-0.7,0.5-0.9,0.8c-0.3,0.4-0.4,0.9-0.5,1.5
		c0,0.8,0.1,1.3,0.4,1.7c0.3,0.4,0.7,0.6,1.1,0.6c0.3,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.5-0.4c0.2-0.2,0.3-0.4,0.5-0.8
		c0.2-0.3,0.3-0.7,0.5-1.2c0.4-0.9,0.8-1.6,1.3-2c0.5-0.4,1.2-0.6,2-0.5c0.8,0.1,1.4,0.4,1.8,1c0.4,0.6,0.5,1.4,0.5,2.3
		C111.5,419,111.3,419.7,111,420.2z M110,423.9c0.3,0.4,0.6,0.8,0.9,1.3c0.3,0.5,0.4,1.2,0.4,2c0,0.5-0.1,1-0.2,1.4
		c-0.1,0.4-0.4,0.8-0.6,1.1c-0.3,0.3-0.7,0.6-1.1,0.7c-0.4,0.2-1,0.3-1.6,0.3c-2.1,0-4.1,0-6.2,0c0-0.3,0-0.5,0-0.8
		c2.1,0,4.1,0,6.2,0c0.5,0,1-0.1,1.3-0.2c0.4-0.1,0.7-0.3,0.9-0.6c0.2-0.3,0.4-0.6,0.5-0.9c0.1-0.4,0.2-0.7,0.2-1.2
		c0-0.7-0.1-1.3-0.4-1.9c-0.3-0.5-0.6-1-1-1.4c-2.5-0.1-5-0.2-7.6-0.2c0-0.3,0-0.5,0-0.8c3.2,0.1,6.3,0.2,9.5,0.3c0,0.2,0,0.4,0,0.6
		C110.7,423.8,110.3,423.8,110,423.9z M110.8,438.8c-0.3,0.4-0.8,0.5-1.4,0.6c-2.4,0.1-4.8,0.2-7.1,0.3c0,0.6,0.1,1.2,0.1,1.8
		c-0.2,0-0.4,0-0.6,0c0-0.6-0.1-1.2-0.1-1.8c-0.8,0-1.7,0.1-2.5,0.1c0-0.3,0-0.5,0-0.8c0.8,0,1.7-0.1,2.5-0.1c0-0.9-0.1-1.8-0.1-2.7
		c0.2,0,0.4,0,0.6,0c0,0.9,0.1,1.8,0.1,2.7c2.3-0.1,4.6-0.2,7-0.3c0.5,0,0.9-0.1,1.1-0.4c0.2-0.2,0.3-0.6,0.3-1c0-0.3,0-0.5-0.1-0.6
		c-0.1-0.2-0.2-0.3-0.3-0.5c0.2-0.1,0.4-0.2,0.6-0.3c0.2,0.2,0.3,0.5,0.4,0.7c0.1,0.2,0.1,0.6,0.1,1
		C111.3,438,111.2,438.5,110.8,438.8z M111.4,446.7c-0.2,0.5-0.5,1-0.9,1.4c-0.4,0.4-0.9,0.7-1.5,1c-0.6,0.3-1.3,0.4-2,0.5
		c-0.8,0.1-1.5,0-2.1-0.1c-0.6-0.2-1.2-0.4-1.6-0.8c-0.5-0.3-0.8-0.8-1.1-1.3c-0.3-0.5-0.4-1.1-0.5-1.7c0-0.5,0-0.9,0.1-1.3
		c0.1-0.4,0.2-0.7,0.4-1c0.2-0.3,0.3-0.5,0.6-0.7c0.2-0.2,0.4-0.4,0.7-0.5c0.1,0.2,0.2,0.4,0.4,0.6c-0.2,0.1-0.4,0.3-0.6,0.4
		c-0.2,0.2-0.3,0.4-0.5,0.6c-0.1,0.2-0.2,0.5-0.3,0.8c-0.1,0.3-0.1,0.6-0.1,1c0,0.6,0.2,1.1,0.5,1.5c0.3,0.4,0.6,0.8,1,1
		c0.4,0.3,0.9,0.5,1.4,0.6c0.5,0.1,1.1,0.1,1.7,0.1c0.6-0.1,1.2-0.2,1.7-0.4c0.5-0.2,1-0.5,1.3-0.8c0.4-0.3,0.6-0.7,0.8-1.2
		c0.2-0.4,0.3-0.9,0.2-1.5c0-0.7-0.2-1.2-0.5-1.6c-0.3-0.4-0.7-0.8-1.2-1.1c0.1-0.2,0.2-0.4,0.3-0.6c0.2,0.2,0.5,0.3,0.7,0.5
		c0.2,0.2,0.4,0.4,0.6,0.7c0.2,0.3,0.3,0.6,0.5,0.9c0.1,0.3,0.2,0.7,0.2,1.2C111.7,445.6,111.6,446.1,111.4,446.7z M111.4,453.1
		c-0.3-0.5-0.6-0.8-1-1.1c-1.3,0.1-2.6,0.3-3.9,0.4c0.1,0.7,0.2,1.3,0.4,2c0.2,0.6,0.4,1.2,0.7,1.7c0.3,0.5,0.6,0.9,1.1,1.2
		c0.4,0.3,0.9,0.4,1.5,0.3c0.4,0,0.7-0.2,1-0.3c0.3-0.2,0.5-0.4,0.6-0.7c0.1-0.3,0.2-0.5,0.3-0.9c0.1-0.3,0.1-0.6,0-1
		C111.9,454.1,111.7,453.6,111.4,453.1z M112.1,457.2c-0.4,0.6-1.1,1-2,1.1c-0.7,0.1-1.3,0-1.8-0.3c-0.5-0.3-0.9-0.7-1.3-1.3
		c-0.3-0.6-0.6-1.2-0.8-2c-0.2-0.7-0.3-1.5-0.4-2.3c-0.2,0-0.4,0-0.6,0.1c-0.7,0.1-1.2,0.3-1.6,0.8c-0.3,0.5-0.5,1.1-0.4,1.9
		c0.1,0.6,0.2,1.1,0.5,1.5c0.3,0.4,0.6,0.7,0.9,1c-0.1,0.2-0.2,0.4-0.4,0.6c-0.4-0.3-0.7-0.6-1.1-1.1c-0.3-0.5-0.6-1.1-0.6-1.8
		c-0.1-1.1,0-1.9,0.5-2.5c0.5-0.6,1.2-0.9,2.1-1c2.3-0.2,4.5-0.4,6.8-0.7c0,0.2,0,0.4,0.1,0.7c-0.3,0-0.6,0.1-0.8,0.1
		c0.4,0.3,0.6,0.7,0.9,1.1c0.2,0.4,0.4,1,0.5,1.8C112.7,455.8,112.5,456.6,112.1,457.2z M113,461.7c-0.3,0.4-0.7,0.6-1.4,0.7
		c-2.4,0.4-4.7,0.7-7.1,1.1c0.1,0.6,0.2,1.2,0.3,1.7c-0.2,0-0.4,0.1-0.6,0.1c-0.1-0.6-0.2-1.2-0.3-1.7c-0.8,0.1-1.7,0.3-2.5,0.4
		c0-0.3-0.1-0.5-0.1-0.8c0.8-0.1,1.7-0.2,2.5-0.4c-0.1-0.9-0.3-1.8-0.4-2.7c0.2,0,0.4-0.1,0.6-0.1c0.1,0.9,0.2,1.8,0.4,2.7
		c2.3-0.3,4.6-0.7,6.9-1c0.5-0.1,0.9-0.2,1.1-0.5c0.2-0.3,0.3-0.6,0.2-1c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.2-0.2-0.3-0.3-0.5
		c0.2-0.1,0.3-0.3,0.5-0.4c0.2,0.2,0.3,0.4,0.4,0.7c0.1,0.2,0.2,0.6,0.2,1C113.4,460.9,113.3,461.3,113,461.7z M106.3,472.3
		c0.4,0.5,0.8,0.9,1.2,1.2c2.5-0.5,5.1-1,7.6-1.5c0,0.2,0.1,0.5,0.1,0.7c-3.1,0.6-6.2,1.3-9.3,1.9c0-0.2-0.1-0.4-0.1-0.7
		c0.3-0.1,0.6-0.2,0.9-0.3c-0.2-0.2-0.4-0.4-0.6-0.6c-0.2-0.2-0.4-0.4-0.5-0.7c-0.2-0.3-0.3-0.5-0.4-0.9c-0.1-0.3-0.2-0.7-0.3-1.1
		c-0.2-1.2-0.1-2.1,0.4-2.9c0.5-0.7,1.4-1.2,2.6-1.4c2-0.3,3.9-0.7,5.9-1c0,0.2,0.1,0.5,0.1,0.7c-2,0.3-4,0.7-6.1,1
		c-0.9,0.2-1.6,0.5-2,1.1c-0.4,0.6-0.6,1.4-0.4,2.3C105.7,471.1,105.9,471.8,106.3,472.3z M116.2,479c-0.1-0.6-0.4-1-0.7-1.4
		c-0.4-0.4-0.8-0.7-1.2-0.9c-0.5-0.2-1-0.3-1.5-0.3c-0.5,0-1.1,0-1.6,0.1c-0.5,0.1-1,0.3-1.5,0.6c-0.5,0.3-0.9,0.6-1.2,1
		c-0.3,0.4-0.6,0.8-0.7,1.3c-0.1,0.5-0.1,1.1,0,1.7c0.1,0.6,0.4,1.1,0.7,1.5c0.3,0.4,0.8,0.7,1.2,0.9c0.5,0.2,1,0.3,1.5,0.3
		c0.5,0,1.1,0,1.6-0.2c0.5-0.1,1-0.3,1.5-0.6c0.5-0.3,0.9-0.6,1.2-1c0.3-0.4,0.6-0.8,0.7-1.3C116.4,480.1,116.4,479.5,116.2,479z
		 M116.9,480.7c-0.1,0.6-0.4,1.1-0.8,1.6c-0.4,0.5-0.8,0.9-1.4,1.2c-0.5,0.3-1.1,0.6-1.8,0.7c-0.6,0.2-1.2,0.2-1.9,0.2
		c-0.6,0-1.2-0.2-1.7-0.4c-0.5-0.2-1-0.6-1.4-1.1c-0.4-0.5-0.7-1.1-0.9-1.8c-0.2-0.7-0.2-1.3,0-1.9c0.1-0.6,0.4-1.1,0.8-1.6
		c0.4-0.5,0.8-0.9,1.4-1.2c0.6-0.3,1.1-0.5,1.8-0.7c0.7-0.1,1.3-0.2,1.9-0.1c0.6,0.1,1.2,0.2,1.7,0.5c0.5,0.3,1,0.6,1.4,1.1
		c0.4,0.5,0.7,1,0.8,1.7C117,479.5,117,480.1,116.9,480.7z M119.2,489c-0.1,0.6-0.3,1.1-0.6,1.6c-0.3,0.5-0.7,0.9-1.3,1.3
		c-0.5,0.4-1.2,0.7-1.9,0.9c-0.8,0.2-1.5,0.3-2.1,0.3c-0.7,0-1.2-0.2-1.8-0.4c-0.5-0.2-1-0.6-1.3-1c-0.4-0.4-0.6-1-0.8-1.6
		c-0.1-0.5-0.2-0.9-0.2-1.3c0-0.4,0.1-0.7,0.1-1c0.1-0.3,0.2-0.6,0.4-0.8c0.2-0.2,0.4-0.5,0.6-0.7c0.2,0.2,0.3,0.4,0.5,0.6
		c-0.2,0.2-0.3,0.3-0.5,0.5c-0.1,0.2-0.3,0.4-0.3,0.7c-0.1,0.3-0.1,0.5-0.1,0.8c0,0.3,0,0.7,0.1,1c0.2,0.6,0.4,1,0.8,1.4
		c0.3,0.4,0.8,0.6,1.2,0.8c0.5,0.2,1,0.3,1.5,0.3c0.5,0,1.1-0.1,1.7-0.3c0.6-0.2,1.1-0.4,1.6-0.7c0.5-0.3,0.8-0.7,1.1-1.1
		c0.3-0.4,0.5-0.8,0.5-1.3c0.1-0.5,0.1-1-0.1-1.5c-0.2-0.6-0.5-1.1-0.8-1.5c-0.4-0.4-0.8-0.6-1.4-0.8c0.1-0.2,0.1-0.5,0.2-0.7
		c0.3,0.1,0.5,0.2,0.8,0.4c0.3,0.1,0.5,0.3,0.7,0.6c0.2,0.2,0.4,0.5,0.6,0.8c0.2,0.3,0.3,0.7,0.5,1.1
		C119.2,487.8,119.3,488.4,119.2,489z"/>
</g>
                    </NavLink>
                    <NavLink to="/products" exact>       <g id="Products" className="menushow" onClick={this.showProducts}>
                        <path className="nav-dial5" d="M951.3,387c0,0,0.2-49.6-13.9-104.8c0,0-9.8-34.8-30.6-78.1l-86.1,77.6c0,0,16.9,72.7,17.8,107.3L951.3,387z"
                        />
                        <path className="nav-dial6" d="M901.2,355.6c-0.3,0.5-0.6,0.8-1.1,1.1c-0.1-0.2-0.2-0.4-0.3-0.6c0.3-0.2,0.6-0.5,0.9-0.9
                            c0.2-0.4,0.4-0.9,0.4-1.5c0-0.8-0.1-1.3-0.5-1.7c-0.3-0.4-0.7-0.6-1.2-0.6c-0.3,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.2-0.5,0.4
		c-0.2,0.2-0.3,0.5-0.4,0.8c-0.1,0.3-0.3,0.8-0.5,1.3c-0.3,0.9-0.7,1.6-1.2,2.1c-0.5,0.4-1.1,0.6-2,0.6c-0.8,0-1.4-0.3-1.9-1
		c-0.4-0.6-0.6-1.4-0.6-2.3c0-0.9,0.2-1.5,0.5-2.1c0.3-0.5,0.7-0.9,1.1-1.2c0.1,0.2,0.3,0.4,0.4,0.6c-0.4,0.3-0.7,0.6-0.9,1.1
		c-0.3,0.4-0.4,1-0.4,1.6c0,0.7,0.1,1.3,0.5,1.8c0.3,0.5,0.8,0.7,1.4,0.7c0.4,0,0.7,0,0.9-0.1c0.3-0.1,0.5-0.3,0.7-0.5
		c0.2-0.2,0.4-0.5,0.6-0.8c0.2-0.4,0.3-0.8,0.5-1.3c0.3-0.9,0.7-1.6,1-2c0.4-0.4,0.9-0.6,1.5-0.6c0.7,0,1.2,0.3,1.6,0.8
		c0.4,0.5,0.6,1.3,0.6,2.3C901.6,354.5,901.5,355.1,901.2,355.6z M901.3,346.6c0,0.9,0,1.8,0.1,2.7c-0.2,0-0.4,0-0.6,0
		c0-0.9,0-1.8,0-2.7c-2.3,0.1-4.6,0.1-7,0.2c-0.5,0-0.9,0.1-1.1,0.4c-0.2,0.2-0.3,0.6-0.3,1c0,0.3,0,0.5,0.1,0.7
		c0.1,0.2,0.2,0.4,0.3,0.5c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1-0.2-0.3-0.5-0.3-0.7c-0.1-0.3-0.1-0.6-0.1-1c0-0.5,0.1-1,0.5-1.3
		c0.3-0.4,0.8-0.5,1.4-0.6c2.4-0.1,4.8-0.1,7.1-0.2c0-0.6,0-1.2-0.1-1.8c0.2,0,0.4,0,0.6,0c0,0.6,0,1.2,0.1,1.8c0.8,0,1.7,0,2.5-0.1
		c0,0.3,0,0.5,0,0.8C903,346.5,902.2,346.5,901.3,346.6z M901.2,341.1c-0.1,0.4-0.2,0.7-0.4,1c-0.2,0.3-0.4,0.5-0.6,0.7
		c-0.2,0.2-0.5,0.4-0.7,0.5c-0.1-0.2-0.2-0.4-0.4-0.7c0.2-0.1,0.4-0.3,0.6-0.4c0.2-0.2,0.3-0.4,0.5-0.6c0.1-0.2,0.2-0.5,0.3-0.8
		s0.1-0.7,0.1-1.1c0-0.6-0.2-1.1-0.5-1.5c-0.3-0.4-0.6-0.8-1-1.1c-0.4-0.3-0.9-0.5-1.4-0.6c-0.5-0.1-1.1-0.1-1.7-0.1
		c-0.6,0.1-1.2,0.2-1.7,0.4c-0.5,0.2-1,0.5-1.3,0.8c-0.4,0.3-0.6,0.7-0.8,1.2c-0.2,0.4-0.3,0.9-0.2,1.5c0,0.7,0.2,1.2,0.5,1.6
		c0.3,0.4,0.7,0.8,1.2,1.1c-0.1,0.2-0.2,0.4-0.4,0.6c-0.2-0.2-0.5-0.3-0.7-0.5c-0.2-0.2-0.4-0.4-0.6-0.7c-0.2-0.3-0.3-0.6-0.4-0.9
		c-0.1-0.3-0.2-0.7-0.2-1.2c0-0.6,0-1.2,0.2-1.7c0.2-0.5,0.5-1,0.9-1.4c0.4-0.4,0.9-0.7,1.5-1c0.6-0.3,1.3-0.4,2-0.5
		c0.8-0.1,1.5,0,2.1,0.2s1.2,0.4,1.6,0.8c0.5,0.4,0.8,0.8,1.1,1.3c0.3,0.5,0.4,1.1,0.5,1.7C901.3,340.3,901.3,340.7,901.2,341.1z
		 M891.7,331.9c0.3,0.5,0.7,0.9,1.2,1.3c2.5-0.3,5-0.5,7.5-0.8c0,0.3,0.1,0.5,0.1,0.8c-3.2,0.3-6.3,0.6-9.5,0.9c0-0.2,0-0.4-0.1-0.6
		c0.4-0.1,0.7-0.1,1.1-0.2c-0.4-0.3-0.7-0.7-1-1.2c-0.3-0.5-0.5-1.1-0.6-1.9c-0.1-0.5-0.1-1,0-1.5c0.1-0.5,0.2-0.9,0.5-1.2
		c0.2-0.4,0.6-0.6,1-0.9c0.4-0.2,0.9-0.4,1.5-0.5c2.1-0.3,4.1-0.6,6.2-0.9c0,0.3,0.1,0.5,0.1,0.8c-2,0.3-4.1,0.6-6.1,0.8
		c-0.5,0.1-0.9,0.2-1.3,0.4c-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.3,0.6-0.4,1c-0.1,0.4-0.1,0.8,0,1.2
		C891.1,330.9,891.4,331.4,891.7,331.9z M898.2,319.2c-0.1-0.6-0.3-1-0.6-1.5c-0.3-0.4-0.6-0.8-1.1-1.1c-0.4-0.3-0.9-0.5-1.5-0.6
		c-0.6-0.1-1.2-0.1-1.9,0.1c-1.3,0.3-2.3,0.8-3,1.6c-0.6,0.8-0.9,1.7-0.7,2.8c0.1,0.7,0.3,1.2,0.7,1.6c0.3,0.4,0.7,0.8,1.1,1
		c2.1-0.3,4.2-0.7,6.3-1c0.2-0.3,0.4-0.7,0.5-1.2C898.3,320.4,898.3,319.8,898.2,319.2z M903,322.1c-4.4,0.7-8.8,1.4-13.2,2
		c0-0.2-0.1-0.4-0.1-0.6c0.3-0.1,0.6-0.2,0.8-0.3c-0.3-0.2-0.7-0.6-1-1c-0.3-0.4-0.5-1-0.6-1.7c-0.1-0.6-0.1-1.2,0-1.8
		c0.1-0.6,0.4-1.1,0.7-1.5c0.4-0.5,0.8-0.8,1.4-1.2c0.6-0.3,1.2-0.6,2-0.7c0.8-0.2,1.5-0.2,2.1-0.1c0.7,0.1,1.2,0.3,1.7,0.7
		c0.5,0.3,0.9,0.8,1.2,1.3c0.3,0.5,0.5,1.1,0.7,1.7c0.1,0.7,0.1,1.3,0.1,1.8c-0.1,0.5-0.2,0.8-0.4,1.1c1.4-0.2,2.9-0.5,4.3-0.7
		C902.9,321.6,902.9,321.8,903,322.1z M896.1,308.6c-0.1-0.6-0.4-1.1-0.7-1.5c-0.4-0.4-0.8-0.7-1.2-0.9c-0.5-0.2-1-0.3-1.5-0.3
		c-0.5,0-1.1,0-1.6,0.2c-0.5,0.1-1,0.3-1.5,0.6c-0.5,0.3-0.9,0.6-1.2,1c-0.3,0.4-0.6,0.8-0.7,1.3c-0.1,0.5-0.2,1,0,1.6
		c0.1,0.6,0.4,1.1,0.7,1.4c0.4,0.4,0.8,0.7,1.2,0.9c0.5,0.2,1,0.3,1.5,0.4c0.5,0,1.1,0,1.6-0.1c0.5-0.1,1-0.3,1.5-0.6
		c0.5-0.3,0.9-0.6,1.2-1c0.3-0.4,0.6-0.8,0.7-1.3C896.2,309.7,896.2,309.2,896.1,308.6z M896.7,310.4c-0.1,0.6-0.4,1.1-0.8,1.6
		c-0.4,0.5-0.8,0.9-1.4,1.2c-0.6,0.3-1.1,0.5-1.8,0.7c-0.7,0.1-1.3,0.2-1.9,0.1c-0.6-0.1-1.2-0.2-1.7-0.5c-0.5-0.3-1-0.6-1.4-1.1
		c-0.4-0.5-0.6-1-0.8-1.7c-0.2-0.7-0.2-1.3,0-1.9c0.1-0.6,0.4-1.1,0.8-1.6c0.4-0.5,0.8-0.9,1.4-1.2c0.5-0.3,1.1-0.6,1.8-0.7
		c0.6-0.2,1.2-0.2,1.9-0.2c0.6,0,1.2,0.2,1.7,0.4c0.5,0.2,1,0.6,1.4,1.1c0.4,0.5,0.7,1.1,0.9,1.8
		C896.9,309.1,896.9,309.8,896.7,310.4z M894.6,303.6c0-0.1,0-0.3,0-0.5c0-0.2-0.1-0.4-0.1-0.6c-0.1-0.2-0.2-0.5-0.3-0.7
		c-0.2-0.2-0.3-0.4-0.5-0.6c-0.2-0.2-0.4-0.3-0.6-0.5c-0.2-0.1-0.4-0.3-0.7-0.3c-2.4,0.7-4.9,1.4-7.3,2.1c-0.1-0.2-0.1-0.5-0.2-0.7
		c3-0.9,6.1-1.8,9.1-2.7c0.1,0.2,0.1,0.4,0.2,0.6c-0.3,0.1-0.7,0.2-1,0.4c0.5,0.2,0.8,0.5,1.2,0.9c0.4,0.4,0.6,0.8,0.8,1.4
		c0.1,0.5,0.2,0.9,0.2,1.2C895.1,303.6,894.9,303.6,894.6,303.6z M891.6,292.8c-0.2-0.6-0.5-1.1-0.9-1.5c-0.4-0.4-0.8-0.7-1.2-0.9
		c-2.1,0.7-4.1,1.4-6.2,2.2c-0.1,0.4-0.2,0.8-0.2,1.3c0,0.5,0.1,1,0.2,1.5c0.4,1.1,1,1.9,2,2.3c1,0.4,2.1,0.4,3.4,0
		c0.6-0.2,1.1-0.4,1.6-0.7c0.5-0.3,0.8-0.6,1.1-1.1c0.3-0.4,0.4-0.9,0.5-1.4C891.9,294,891.8,293.4,891.6,292.8z M892,296.2
		c-0.6,1-1.6,1.7-3.1,2.2c-0.7,0.2-1.4,0.3-2.1,0.3c-0.7,0-1.3-0.2-1.8-0.4c-0.5-0.2-1-0.6-1.4-1.1c-0.4-0.5-0.7-1-0.9-1.7
		c-0.2-0.6-0.3-1.1-0.3-1.5c0-0.5,0.1-0.8,0.1-1.1c-1.4,0.5-2.7,0.9-4.1,1.4c-0.1-0.2-0.2-0.5-0.2-0.7c4.2-1.5,8.4-2.9,12.5-4.4
		c0.1,0.2,0.2,0.4,0.2,0.7c-0.3,0.1-0.5,0.2-0.8,0.4c0.2,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.3,0.6,0.5c0.2,0.2,0.4,0.4,0.5,0.7
		c0.2,0.3,0.3,0.6,0.4,1C892.7,294,892.6,295.2,892,296.2z"/>
</g>
                    </NavLink>

                    <NavLink to="/team" exact>
                        <g id="Team" className="menushow" onClick={this.showTeam}>
                            <path className="nav-dial5" d="M951.1,392l-112.7,1c0,0,0.7,68.3-12,96l95.8,81C922.2,570.1,955.5,493.2,951.1,392z" />
                            <path className="nav-dial6" d="M896.8,460.8c-0.3,0-0.6-0.1-1-0.1c0.2,0.4,0.4,0.9,0.6,1.5c0.2,0.6,0.2,1.3,0,2.1c-0.2,0.7-0.4,1.3-0.7,1.7
                                c-0.3,0.4-0.6,0.7-1,0.8c0.2,0.5,0.3,1,0.4,1.6c0.1,0.6,0,1.3-0.2,2.1c-0.3,1.2-0.9,2-1.7,2.5c-0.8,0.5-1.7,0.6-2.8,0.2
		c-2-0.6-4-1.2-6-1.8c0.1-0.2,0.1-0.5,0.2-0.7c2,0.6,4,1.2,6,1.8c0.9,0.3,1.7,0.2,2.3-0.2c0.6-0.4,1-1.1,1.3-1.9
		c0.2-0.7,0.2-1.3,0.2-1.8c-0.1-0.5-0.2-1-0.4-1.5c-0.2,0.1-0.5,0.1-0.8,0.1c-0.3,0-0.6,0-0.9-0.1c-2.1-0.5-4.1-1-6.2-1.5
		c0.1-0.2,0.1-0.5,0.2-0.7c2.1,0.5,4.2,1,6.2,1.4c0.7,0.2,1.4,0.1,2-0.3c0.6-0.4,1-1,1.2-2c0.1-0.7,0.1-1.3-0.1-1.9
		c-0.2-0.6-0.4-1.2-0.7-1.6c-2.5-0.4-5.1-0.9-7.6-1.3c0-0.2,0.1-0.5,0.1-0.7c3.1,0.5,6.3,1,9.4,1.6
		C896.9,460.3,896.8,460.6,896.8,460.8z M893.5,452c-0.2-0.6-0.4-1.1-0.8-1.4s-0.8-0.6-1.4-0.6c-0.4,0-0.7,0-1,0.1
		c-0.3,0.1-0.5,0.3-0.7,0.5c-0.2,0.2-0.4,0.5-0.5,0.8c-0.1,0.3-0.2,0.6-0.2,1c-0.1,0.6,0,1.2,0.2,1.7c0.2,0.5,0.4,1,0.7,1.4
		c1.3,0.2,2.6,0.4,3.9,0.5c0.1-0.7,0.1-1.4,0.1-2.1C893.7,453.3,893.7,452.6,893.5,452z M898,454c-0.1,1.2-0.5,2-1.1,2.5
		c-0.6,0.5-1.3,0.7-2.3,0.5c-2.2-0.3-4.5-0.6-6.8-1c0-0.2,0.1-0.4,0.1-0.7c0.3,0,0.6,0,0.8,0.1c-0.3-0.4-0.5-0.8-0.6-1.3
		c-0.1-0.5-0.2-1.1-0.1-1.9c0.1-1,0.4-1.7,1-2.3c0.6-0.5,1.3-0.8,2.2-0.7c0.7,0.1,1.3,0.3,1.7,0.7c0.4,0.4,0.8,0.9,1,1.6
		c0.2,0.6,0.3,1.4,0.3,2.2c0,0.8,0,1.6-0.1,2.5c0.2,0,0.4,0.1,0.6,0.1c0.7,0.1,1.3-0.1,1.7-0.4c0.4-0.4,0.7-1,0.8-1.8
		c0.1-0.6,0-1.2-0.2-1.7c-0.2-0.5-0.4-0.9-0.7-1.2c0.2-0.2,0.3-0.3,0.5-0.5c0.3,0.4,0.6,0.8,0.8,1.4
		C898.1,452.5,898.1,453.2,898,454z M897.9,442.6c-0.1-0.4-0.3-0.8-0.6-1.1c-0.3-0.3-0.6-0.6-1.1-0.8c-0.4-0.2-1-0.4-1.6-0.4
		c0,2.3,0,4.6-0.2,7c0.6,0,1.1-0.1,1.6-0.3c0.5-0.2,0.8-0.4,1.1-0.7c0.3-0.3,0.5-0.6,0.7-1c0.1-0.4,0.2-0.8,0.2-1.2
		C898.1,443.5,898.1,443,897.9,442.6z M898.3,445.8c-0.3,0.5-0.6,0.9-1,1.3c-0.4,0.3-1,0.6-1.6,0.8c-0.6,0.2-1.3,0.2-2,0.2
		c0.2-2.6,0.2-5.2,0.2-7.8c-1.5,0-2.6,0.3-3.4,1c-0.8,0.6-1.2,1.5-1.2,2.7c0,0.8,0.1,1.4,0.5,1.9c0.3,0.5,0.7,0.9,1.3,1.3
		c-0.1,0.2-0.2,0.4-0.4,0.6c-0.3-0.2-0.5-0.4-0.8-0.6c-0.2-0.2-0.5-0.5-0.6-0.8c-0.2-0.3-0.3-0.7-0.4-1.1c-0.1-0.4-0.2-0.9-0.1-1.4
		c0-1.4,0.5-2.4,1.4-3.2c0.9-0.8,2.1-1.2,3.6-1.2c0.8,0,1.5,0.1,2.1,0.3c0.6,0.2,1.2,0.5,1.6,0.9c0.4,0.4,0.8,0.9,1,1.4
		c0.2,0.6,0.3,1.2,0.3,1.8C898.7,444.7,898.6,445.3,898.3,445.8z M898.4,435.4c0,1,0.1,1.9,0.1,2.9c-0.2,0-0.4,0-0.6,0
		c0-1-0.1-1.9-0.1-2.9c-2.3,0.1-4.6,0.2-7,0.3c-0.5,0-0.9,0.2-1.1,0.4c-0.2,0.2-0.3,0.6-0.3,1c0,0.3,0,0.5,0.1,0.7
		c0.1,0.2,0.2,0.4,0.3,0.6c-0.2,0.1-0.4,0.2-0.6,0.4c-0.2-0.2-0.3-0.5-0.4-0.7c-0.1-0.3-0.1-0.6-0.1-1c0-0.5,0.1-1,0.5-1.4
		c0.3-0.4,0.8-0.6,1.4-0.6c2.4-0.1,4.8-0.3,7.1-0.4c0-0.6-0.1-1.2-0.1-1.9c0.2,0,0.4,0,0.6,0c0,0.6,0.1,1.2,0.1,1.9
		c0.8,0,1.7-0.1,2.5-0.1c0,0.3,0,0.6,0,0.8C900.1,435.3,899.2,435.3,898.4,435.4z"/>
            </g>
                    </NavLink>
                </svg>


            </div >
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterMenu);




// WEBPACK FOOTER //
// src/components/Home/RegisterMenu.js